import { PostHogConfig } from '../context';

const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';

export const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY;
export const POSTHOG_HOST = 'https://us.i.posthog.com';

export const AI_BEES_EMAIL_DOMAINS = ['@ai-bees.io', '@ai-ark.io'] as const;

export const POSTHOG_CONFIG: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  disable_session_recording: false,
  debug: APP_STAGE === 'dev',
};
